import {
    Box,
    Button,
    FormControl,
    Grid2,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    Link,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import { toast } from "react-toastify"
import api from "../../services/api"

import { FileUploader } from "react-drag-drop-files"

import DeleteIcon from "@mui/icons-material/Delete"

import { useParams } from "react-router-dom"

import { useHistory } from "react-router-dom"
import ColorPicker from "../../components/ColorPicker"
import ModalQuestion from "./ModalQuestion"
import InputMask from "react-input-mask"

const fileTypes = ["JPG", "PNG"]

function NewForm() {
    const history = useHistory()
    const { id } = useParams()
    const [form, setForm] = useState({
        status: "draft",
        questions: [],
    })
    const [loading, setLoading] = useState(false)
    const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false)
    const [openModalQuestion, setOpenModalQuestion] = useState(false)

    const [products, setProducts] = useState([])

    async function checkCreatedForm() {
        if (!form.id) {
            await createFormAsDraft()
        }
    }

    async function createFormAsDraft() {
        try {
            const res = await api.post("/forms", form)
            setForm({ ...res.data, questions: [] })
        } catch (error) {
            toast.error("Erro ao salvar formulário")
        }
    }

    async function getForm() {
        try {
            const res = await api.get(`/forms/${id}`)
            setForm(res.data)
        } catch (error) {
            toast.error("Erro ao buscar dados do formulário")
        }
    }

    useEffect(() => {
        if (id) {
            getForm()
        }
    }, [id])

    const onChangeValue = (key, value) => {
        setForm({
            ...form,
            [key]: value,
        })
    }

    const handleChange = (event) => {
        onChangeValue("status", event.target.value)
    }

    const handleChangeFile = async (file, uploadType) => {
        try {
            setLoading(true)

            const formData = new FormData()
            formData.append("file", file)
            formData.append("type", uploadType)

            const res = await api.post(
                `/forms/${form.id}/media-upload`,
                formData,
            )

            setForm({
                ...form,
                [uploadType]: res.data.firebaseUrl,
            })

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao fazer upload de imagem")
        }
    }

    const handleDeleteMedia = async (mediaType) => {
        try {
            setLoading(true)
            await api.delete(`/forms/${form.id}/media/?mediaType=${mediaType}`)
            setForm({
                ...form,
                [mediaType]: null,
            })
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao excluir imagem")
        }
    }

    const handleSaveForm = async () => {
        try {
            setLoading(true)

            form.agentNumber = form.agentNumber.replace(/\D/g, "")

            if (!form.id) {
                await checkCreatedForm()
            } else {
                await api.put(`/forms/${form.id}`, form)
            }

            toast.success("Formulário salvo com sucesso")

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao salvar formulário")
        }
    }

    const handleSaveQuestion = async (question) => {
        try {
            setLoading(true)

            const payload = { ...question }
            payload.formId = form.id

            const res = await api.post("/formQuestions", payload)

            question.id = res.data.id

            const arr = [...form.questions]

            arr.push(question)

            setForm({
                ...form,
                questions: arr,
            })

            setOpenModalQuestion(false)

            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
            toast.error("Erro ao salvar pergunta")
        }
    }

    const handleDeleteQuestion = async (questionId) => {
        try {
            setLoading(true)
            await api.delete(`/formQuestions/${questionId}`)

            const arr = [
                ...form.questions.filter((item) => item.id !== questionId),
            ]

            setForm({
                ...form,
                questions: arr,
            })

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao excluir pergunta")
        }
    }

    async function getProducts() {
        try {
            setLoading(true)

            const res = await api.get("/products")
            setProducts(res.data)

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao buscar products")
        }
    }

    const handlePublish = async () => {
        try {
            setLoading(true)

            if (!form.questions.length) {
                toast.error("Insira pelo menos uma pergunta para continuar")
                return
            }

            if (!form.title) {
                toast.error("Insira um título para o formulário")
                setLoading(false)
                return
            }

            await api.put(`/forms/${form.id}`, {
                ...form,
                status: "active",
            })

            setForm({
                ...form,
                status: "active",
            })

            toast.success("Formulário publicado com sucesso!")

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error(error)
        }
    }

    useEffect(() => {
        getProducts()
    }, [])

    return (
        <MainContainer>
            <MainHeader>
                <Title>Formulário</Title>
            </MainHeader>
            {!form.id && (
                <Typography variant="subtitle1">
                    Digite um nome para o seu formulário e clique em salvar para
                    continuar
                </Typography>
            )}

            <ModalQuestion
                open={openModalQuestion}
                handleClose={() => setOpenModalQuestion(false)}
                handleSave={handleSaveQuestion}
            />

            <ColorPicker
                open={colorPickerModalOpen}
                handleClose={() => setColorPickerModalOpen(false)}
                onChange={(color) => {
                    setForm({
                        ...form,
                        primaryColor: color,
                    })
                }}
            />

            <Box overflow="auto" paddingTop={2} paddingBottom={5}>
                <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            fullWidth
                            label="Título"
                            variant="outlined"
                            value={form.title}
                            onChange={(e) =>
                                onChangeValue("title", e.target.value)
                            }
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 8 }}>
                        <InputMask
                            prefix="teste"
                            mask={"55 (99)99999-9999"}
                            value={form.agentNumber}
                            onChange={(e) =>
                                onChangeValue("agentNumber", e.target.value)
                            }
                        >
                            {(inputProps) => (
                                <TextField
                                    fullWidth
                                    label="Telefone para respostas"
                                    variant="outlined"
                                    placeholder="Seu WhatsApp para receber respostas (5599999999)"
                                    {...inputProps}
                                />
                            )}
                        </InputMask>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth>
                            <InputLabel id="status-select-label">
                                Status
                            </InputLabel>
                            <Select
                                labelId="status-select-label"
                                id="status-select"
                                value={form.status}
                                label="Status"
                                onChange={handleChange}
                                disabled={!form.id}
                            >
                                <MenuItem value={"draft"}>Rascunho</MenuItem>
                                <MenuItem value={"active"}>Publicado</MenuItem>
                                <MenuItem value={"inactive"}>Inativo</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            label="Descrição"
                            fullWidth
                            multiline
                            maxRows={4}
                            value={form.description}
                            onChange={(e) =>
                                onChangeValue("description", e.target.value)
                            }
                        />
                    </Grid2>

                    {!!form.id && (
                        <Grid2 sx={{ width: "100%" }}>
                            <Typography variant="h6">Produto</Typography>

                            <FormControl fullWidth sx={{ mt: 1 }}>
                                <InputLabel id="select-product">
                                    Produto
                                </InputLabel>
                                <Select
                                    labelId="select-product"
                                    id="select-product-form"
                                    value={form?.productId || ""}
                                    label="Produto"
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            productId: e.target.value,
                                        })
                                    }
                                >
                                    {products.map((product) => (
                                        <MenuItem
                                            key={product.id}
                                            value={product.id}
                                        >
                                            {`${product.name} - ${product.medias.length} mídias`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid2>
                    )}

                    {!!form.id && (
                        <Grid2 size={{ xs: 12 }}>
                            <Typography variant="h6">Perguntas</Typography>
                            <Typography
                                variant="caption"
                                color="error"
                                fontWeight="bold"
                            >
                                ATENÇÃO:
                            </Typography>
                            <Typography variant="caption">
                                {" "}
                                Não precisa perguntar nome, telefone e e-mail.
                                Estes campos são adicionados automaticamente
                            </Typography>

                            <Box
                                display="flex"
                                flexDirection="column"
                                gap={1}
                                alignItems="flex-start"
                            >
                                {form.questions?.map((question, i) => (
                                    <Box
                                        key={question.id || i}
                                        display="flex"
                                        width="100%"
                                    >
                                        <TextField
                                            disabled
                                            value={question.questionText}
                                            fullWidth
                                            size="small"
                                        />

                                        <IconButton
                                            onClick={() =>
                                                handleDeleteQuestion(
                                                    question.id,
                                                )
                                            }
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                ))}

                                <Button
                                    variant="contained"
                                    onClick={() => setOpenModalQuestion(true)}
                                >
                                    Nova pergunta
                                </Button>
                            </Box>
                        </Grid2>
                    )}

                    {!!form.id && (
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            {form.logoUrl ? (
                                <Box>
                                    <Typography>Logo da sua empresa</Typography>
                                    <img
                                        src={form.logoUrl}
                                        alt="logo"
                                        height={150}
                                        width={300}
                                        style={{
                                            objectFit: "contain",
                                        }}
                                    />
                                    <Button
                                        size="small"
                                        onClick={() =>
                                            handleDeleteMedia("logoUrl")
                                        }
                                        loading={loading}
                                    >
                                        Remover
                                    </Button>
                                </Box>
                            ) : (
                                <FileUploader
                                    handleChange={(e) =>
                                        handleChangeFile(e, "logoUrl")
                                    }
                                    name="file"
                                    types={fileTypes}
                                    label="Logo da empresa"
                                />
                            )}
                        </Grid2>
                    )}

                    {!!form.id && (
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                ml={1}
                                gap={2}
                            >
                                <Typography>Cor de fundo</Typography>
                                <div
                                    onClick={() =>
                                        setColorPickerModalOpen(true)
                                    }
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        backgroundColor: form.primaryColor,
                                        cursor: "pointer",
                                        border: "solid 1px #3e3e3e",
                                    }}
                                />
                            </Box>
                        </Grid2>
                    )}

                    <Grid2 size={{ xs: 12 }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            gap={1}
                        >
                            <Button
                                onClick={() => history.go(-1)}
                                color="secondary"
                            >
                                Voltar
                            </Button>

                            <Box display="flex" gap={1}>
                                <Button
                                    variant="outlined"
                                    LinkComponent={Link}
                                    target="_blank"
                                    href={`/form-preview/${form.uuid}`}
                                >
                                    Visualizar
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    loading={loading}
                                    onClick={handleSaveForm}
                                >
                                    Salvar
                                </Button>
                                {form.status === "draft" && (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        loading={loading}
                                        onClick={handlePublish}
                                        disabled={!form.id}
                                    >
                                        Publicar
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Grid2>
                </Grid2>
            </Box>
        </MainContainer>
    )
}

export default NewForm
